import { hbs } from 'ember-cli-htmlbars';
export default hbs("<a\n  href={{this.url}}\n  class={{if this.isActive \'active\'}}\n  id={{@id}}\n  {{on \'click\' this.onClick}}\n  ...attributes\n>{{yield}}</a>")